import React from 'react'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'

interface DetailProps {
  listEl: any
  listStatus: string
  userList: any
  documentListing?: any
  mode?: string
}

export const ChangeAssetCategoryDetailContent = (props: DetailProps) => {
  const { listEl, documentListing, listStatus, userList, mode } = props
  const submittedUser = userList?.find(
    (u: any) => u?.ID === listEl?.submittedBy
  )
  const approvedUser = userList?.find((u: any) => u?.ID === listEl?.approvedBy)
  const isSubmitted =
    listEl?.ApprovalStatus === 'SUBMIT' ||
    listEl?.ApprovalStatus === 'COMPLETED'
  const isCompleted = listEl?.ApprovalStatus === 'COMPLETED'

  return (
    <>
      <div className="content-wrap left">
        <div className="desc " style={{ color: 'grey' }}>
          {`Current Asset Category`}
        </div>
        <div className="mdDesc text-noflow">
          {listEl?.OldCategory?.name || 'N/A'}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc " style={{ color: 'grey' }}>
          {`Model No.`}
        </div>
        <div className="mdDesc text-noflow">
          {listEl?.Asset?.model_no || 'N/A'}
        </div>
      </div>

      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          {`New Asset Category`}
        </div>
        <div className="mdDesc text-noflow">
          {listEl?.NewCategory?.name || 'N/A'}
        </div>
      </div>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          {`Description`}
        </div>
        <div className="mdDesc text-noflow">{listEl?.description || 'N/A'}</div>
      </div>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          {`Reason`}
        </div>
        <div className="mdDesc text-noflow">{listEl?.reason || 'N/A'}</div>
      </div>

      {isSubmitted && (
        <>
          <div className="content-wrap left">
            <div className="desc " style={{ color: 'grey' }}>
              {`Submitted By`}
            </div>
            <div className="mdDesc text-noflow">
              {submittedUser?.name || 'N/A'}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc " style={{ color: 'grey' }}>
              {`Submitted Date`}
            </div>
            <div className="mdDesc text-noflow">
              {listEl?.submittedTs ? formatDate(listEl?.submittedTs) : 'N/A'}
            </div>
          </div>
        </>
      )}

      {isCompleted && (
        <>
          <div className="content-wrap left">
            <div className="desc " style={{ color: 'grey' }}>
              {`Approved By`}
            </div>
            <div className="mdDesc text-noflow">
              {approvedUser?.name || 'N/A'}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc " style={{ color: 'grey' }}>
              {`Approved Date`}
            </div>
            <div className="mdDesc text-noflow">
              {listEl?.approvedTs ? formatDate(listEl?.approvedTs) : 'N/A'}
            </div>
          </div>
        </>
      )}
    </>
  )
}
